import tokens from '../atlanticaTokens.json'

export const atlTheme = {
  ...tokens,

  //custom tokens
  BorderRadius100: 100,
  CarouselHeight: 200,
  FontWeight500: 500,
  LineHeightNotification: 14,
  PasswordRecoveryHorizontalMargin: 110,
  SpacingSemiAtomic: 2,
  LineHeight16: 16,
  BorderRadiusCard: 10,
  SpacingIconMarginRight: 84,

  SwipeableListItemContainerHeight: 55,
  SwipeableListItemBackgroundHeight: 60,
  SwipeableListItemForegroundHeight: 85,
}
